import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Table, Tab, Tabs, Form,Pagination } from "react-bootstrap";
import axios from "axios";
import { Progress } from "react-sweet-progress";
import statelist from "../../assets/Json/statedistrict.json";
import { useNavigate } from "react-router-dom";
import * as XLSX from 'xlsx';


function VideoDetailPage() {
  const navigate = useNavigate();
  const [key, setKey] = useState("pending");
  const [response, setResponse] = useState([]);
  const [shortresponse, setshortResponse] = useState([]);
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [StKey, setStKey] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setPostPerPage] = useState(2);
  const lastPostIndex = currentPage * postPerPage;
  const firstPostIndex = lastPostIndex - postPerPage;
  const c_post = shortresponse?.slice(firstPostIndex, lastPostIndex);
  const r_post=response?.slice(firstPostIndex, lastPostIndex);
  const total_page = Math.ceil(shortresponse?.length / postPerPage);
  const page_arr = [...Array(total_page).keys()];

  useEffect(() => {
    let userdata = JSON.parse(localStorage.getItem("user"));
    if (!userdata.role === "admin") {
      navigate("/face-analyser/login");
    }
    setState('');
    setDistrict('');
  }, []);



  useEffect(() => {
    let token = localStorage.getItem("token");
    // window.location.reload()
    let status="validated"
    axios
      .get(
        `https://anuvadiniqa.aicte-india.org/face/fetch_all_vid?state=${state}&district=${district}&status=${status}`,
        {
          headers: {
            Authorization: `Bearer ${
              token
                ? token
                : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoidml2IiwidXNlck5hbWUiOiJ2aXZAbWFpbC5jb20iLCJyb2xlIjoiYWRtaW4iLCJpYXQiOjE2OTIzMzgxNjIsImV4cCI6MTY5MjQyNDU2Mn0.4lK5EKluXKNT432uHkrnECNCL3b0ygULNuqsa6D1lhM"
            }`,
          },
        }
      )
      .then((res) => {
        if (res.data.status == "success") {
          let data = res.data.data;
          console.log(data);
          setResponse(data.videos);
        }
      })
      .catch((err) => {
        console.log(err, `error`);
      });
      let stat = "shorlisted"
    axios
      .get(
        `https://anuvadiniqa.aicte-india.org/face/fetch_shortlisted_vid?state=${state}&district=${district}&status=${stat}`,
        {
          headers: {
            Authorization: `Bearer ${
              token
                ? token
                : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoidml2IiwidXNlck5hbWUiOiJ2aXZAbWFpbC5jb20iLCJyb2xlIjoiYWRtaW4iLCJpYXQiOjE2OTIyNDY2MjMsImV4cCI6MTY5MjMzMzAyM30.6ZtdqhqwpC4mqpvlwOncDonz_GHLoUumUy8k9dDxVSs"
            }`,
          },
        }
      )
      .then((res) => {
        if (res.data.status == "success") {
          let data = res.data.data;
          console.log(data);
          setshortResponse(data.videos);
        }
      });
  }, [state, district]);

  const handlestselect = (key) => {
    setStKey(key);
    setState(statelist.states[key].state);
  };

  const handleShortlist = (id) => {
    const post = {
      _id: id,
      status: "shorlisted",
    };
    axios
      .post("https://anuvadiniqa.aicte-india.org/face/set_shortlisted", post)
      .then((res) => {
        if (res.data.status == "success") {
          alert("sucessfully shortlisted");
          window.location.reload();
        } else alert("something went wrong");
      })
      .catch((err) => {
        console.log("shortlishttps://anuvadiniqa.aicte-india.org/face-analyser/video/formt apii", err);
      });
  };

  const downloadExcel = (data) => {
    let finalObject = data
    for(let i=0;i<data.length;i++){
      let perc = data[i].percentage
      Object.assign(finalObject[i],perc)
      delete finalObject[i]._id
      delete finalObject[i].path
      delete finalObject[i].tokens
      delete finalObject[i].createdAt
      delete finalObject[i].updatedAt
    }
    const worksheet = XLSX.utils.json_to_sheet(finalObject);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, "Shorlisted-Sheet.xlsx");
  };

  return (
    <>
      <div className="banner-allpage-sec">
        <ul className="breadcrumb">
          <li>
            <Link to="/face-analyser/">Home</Link>
          </li>
          <li>Video</li>
          <li>AI Video Analyzer</li>
        </ul>
        <div className="banner-content-sec text-center">
          <h1 className="first-head">PRERANA</h1>
          <h3 className="second-head">
            School of Experiential Learning, A Mission to Inspire India
          </h3>
          <br />
        </div>
      </div>
      <main className="contentarea">
        <section className="vidpage">
          <div className="container">
            <div className="selectstate d-flex justify-content-start text-start">
              <Form.Group className="mb-3 w-50">
                <Form.Label htmlFor="StateSelect">Select State</Form.Label>
                <Form.Select
                  id="StateSelect"
                  className="form-control"
                  onChange={(e) => handlestselect(e.target.value)}
                >
                  <option>Select State</option>
                  {statelist.states.map((index, key) => (
                    <>
                      <option value={key} selected={index.state==state}>{index.state}</option>
                    </>
                  ))}
                </Form.Select>
              </Form.Group>
              {StKey ? (
                <>
                  {" "}
                  <Form.Group className="mb-3 w-50 ml-3">
                    <Form.Label htmlFor="DistrictSelect">
                      Select District
                    </Form.Label>
                    <Form.Select
                      id="DistrictSelect"
                      className="form-control"
                      onClick={(e) => setDistrict(e.target.value)}
                    >
                      <option>Select District</option>
                      {statelist.states[StKey].districts.map((index) => (
                        <>
                          <option value={index}>{index}</option>
                        </>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </>
              ) : (
                <>
                  {" "}
                  <Form.Group className="mb-3 w-50 ml-3">
                    <Form.Label htmlFor="DistrictSelect">
                      Select District
                    </Form.Label>
                    <Form.Select id="DistrictSelect" className="form-control">
                      <option>Select District</option>
                    </Form.Select>
                  </Form.Group>
                </>
              )}
            </div>
                    <div> State : {state} & district : {district}</div>

            <div>
            {/* <div className="videoTab text-end"><button onClick={(e)=>{DownloadExcelButton(shortresponse)}}>Download as Excel</button></div> */}
            </div>
           
            <div className="videoTab text-start">
     
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
              >
                      
                {console.log(key,"this is key")}
                <Tab eventKey="pending" title="Pending">
                  <div className="tabDiv">
                
                    {response && r_post?.map((item, index) => {
                      return (
                        <>
                          <div className="tabDetail mt-4 d-flex justify-content-between align-items-center">
                            <div className="videos">
                              <video
                                width="320"
                                height="240"
                                src={item?.path+`?sp=r&st=2023-01-18T06:07:13Z&se=2028-12-31T14:07:13Z&spr=https&sv=2021-06-08&sr=c&sig=HtVlU%2BSsWizlSOrpTEIr40tfVncy74Og2N4VnG8cTH8%3D`}
                                controls
                              ></video>
                            </div>
                            <div className="tabledata">
                              <Table responsive className="text-start">
                                <tbody>
                                  <tr>
                                    <td>Unique ID</td>
                                    <td>{item.uniqueId}</td>
                                    <td>State</td>
                                    <td>{item.state}</td>
                                  </tr>
                                  <tr>
                                    <td>Student Name</td>
                                    <td>{item.name}</td>
                                    <td>District</td>
                                    <td>{item.district}</td>
                                  </tr>
                                  <tr>
                                    <td>Contact</td>
                                    <td>{item.contact}</td>
                                    <td>School Name</td>
                                    <td>{item.school}</td>
                                  </tr>
                                  <tr>
                                    <td>Email:</td>
                                    <td colSpan={3}>{item.email}</td>
                                  </tr>
                                  <tr>
                                    <td>Emotion</td>
                                    <td colSpan={3}>
                                      <ul>
                                        <li className="d-flex justify-content-between">
                                          <span title="surprice">😲 {'(surprise)'}</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.percentage.surprise
                                            )}
                                          />
                                        </li>
                                        <li className="d-flex justify-content-between">
                                          <span title="Happy">😁 {'(happy)'}</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.percentage.happy
                                            )}
                                          />{" "}
                                        </li>
                                        <li className="d-flex justify-content-between">
                                          <span title="Nutral">🙂 {'(neutral)'}</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.percentage.neutral
                                            )}
                                          />{" "}
                                        </li>
                                        <li className="d-flex justify-content-between">
                                          <span title="Sad">😔 {'(sad)'}</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.percentage.sad
                                            )}
                                          />
                                        </li>
                                        <li className="d-flex justify-content-between">
                                          <span title="angry">🥹 {'(angry)'}</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.percentage.angry
                                            )}
                                          />
                                        </li>
                                        <li className="d-flex justify-content-between">
                                          <span title="fear">😱 {'fear'}</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.percentage.fear
                                            )}
                                          />
                                        </li>
                                      </ul>
                                    </td>
                                  </tr>
                                  {item.creativity?<>
                                    <tr>
                                    <td>Lecturer Rating</td>
                                    <td colSpan={3}>
                                      <ul>
                                        <li className="d-flex justify-content-between">
                                          <span title=" content ">Content</span>
                                          <Progress
                                            percent={Math.floor(
                                              item.content
                                            )}
                                          />
                                        </li>
                                        <li className="d-flex justify-content-between">
                                        <span title=" creativity ">Creativity</span>
                                          <Progress
                                            percent={Math.floor(
                                              item.creativity
                                            )}
                                          />{" "}
                                        </li>
                                        <li className="d-flex justify-content-between">
                                          <span title="Nutral">Enthusiasm</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.enthusiasm
                                            )}
                                          />
                                        </li>
                                        <li className="d-flex justify-content-between">
                                          <span title="Sad">Emotional Stability</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.emotionalStability
                                            )}
                                          />
                                        </li>
                                        <li className="d-flex justify-content-between">
                                          <span title="angry">Comprehansive Ability</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.comprehansiveAbility
                                            )}
                                          />
                                        </li>
                                        {/* <li className="d-flex justify-content-between">
                                          <span title="fear">😱 {'fear'}</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.percentage.fear
                                            )}
                                          />
                                        </li> */}
                                      </ul>
                                    </td>
                                  </tr></>:null}
                               
                                  <tr>
                                    <td>Short Note:</td>
                                    <td colSpan={4}>
                                      {item.discription
                                        ? item.discription
                                        : "no comment available"}
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            </div>
                            <div className="totalScore">
                            <p>leacturer assigned Score</p>
                              <h2>{Math.floor(item.manualScore) + "%"}</h2>
                              <p>Final Score</p>
                              <h2>{Math.floor(item.finalScore) + "%"}</h2>
                              <p>Confidence Score</p>
                              <h2>
                                {Math.floor(item.percentage.percentage) + "%"}
                              </h2>
                              <div className="mt-5">
                                <input
                                  type="checkbox"
                                  className="formcontrol"
                                  id="select"
                                  onClick={() => handleShortlist(item._id)}
                                />
                                <label htmlFor="select">
                                  Select to Shortlist
                                </label>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </div>
                  {response ? (
                    <div className="d-flex justify-content-center">
                      <Pagination>
                        {page_arr.map((i, x) => (
                          <Pagination.Item
                            key={i}
                            onClick={() => {
                              setCurrentPage(i + 1);
                            }}
                            active={i + 1 === currentPage}
                          >
                            {i + 1}
                          </Pagination.Item>
                        ))}
                      </Pagination>
                    </div>
                  ) : (
                    <></>
                  )}
                </Tab>
                <Tab eventKey="shortlist" title="Shortlist">
                  <div className="tabDiv ">
                    <button className="btn btn-success" onClick={()=>{downloadExcel(shortresponse)}}>Download as Excel</button>
                    {shortresponse && c_post?.map((item, index) => {
                      return (
                        <>
                          <div className="tabDetail mt-4 d-flex justify-content-between align-items-center">
                            <div className="videos">
                              <video
                                width="320"
                                height="240"
                                src={item?.path+`?sp=r&st=2023-01-18T06:07:13Z&se=2028-12-31T14:07:13Z&spr=https&sv=2021-06-08&sr=c&sig=HtVlU%2BSsWizlSOrpTEIr40tfVncy74Og2N4VnG8cTH8%3D`}
                                controls
                              ></video>
                            </div>
                            <div className="tabledata">
                              <Table responsive className="text-start">
                                <tbody>
                                  <tr>
                                    <td>Unique ID</td>
                                    <td>{item.uniqueId}</td>
                                    <td>State</td>
                                    <td>{item.state}</td>
                                  </tr>
                                  <tr>
                                    <td>Student Name</td>
                                    <td>{item.name}</td>
                                    <td>District</td>
                                    <td>{item.district}</td>
                                  </tr>
                                  <tr>
                                    <td>Contact</td>
                                    <td>{item.contact}</td>
                                    <td>School Name</td>
                                    <td>{item.school}</td>
                                  </tr>
                                  <tr>
                                    <td>Email:</td>
                                    <td colSpan={3}>{item.email}</td>
                                  </tr>
                                  <tr>
                                    <td>Emotion</td>
                                    <td colSpan={3}>
                                    <ul>
                                        <li className="d-flex justify-content-between">
                                          <span title="surprice">😲 {'(surprise)'}</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.percentage.surprise
                                            )}
                                          />
                                        </li>
                                        <li className="d-flex justify-content-between">
                                          <span title="Happy">😁 {'(happy)'}</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.percentage.happy
                                            )}
                                          />{" "}
                                        </li>
                                        <li className="d-flex justify-content-between">
                                          <span title="Nutral">🙂 {'(neutral)'}</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.percentage.neutral
                                            )}
                                          />{" "}
                                        </li>
                                        <li className="d-flex justify-content-between">
                                          <span title="Sad">😔 {'(sad)'}</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.percentage.sad
                                            )}
                                          />
                                        </li>
                                        <li className="d-flex justify-content-between">
                                          <span title="angry">🥹 {'(angry)'}</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.percentage.angry
                                            )}
                                          />
                                        </li>
                                        <li className="d-flex justify-content-between">
                                          <span title="fear">😱 {'fear'}</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.percentage.fear
                                            )}
                                          />
                                        </li>
                                      </ul>
                                    </td>
                                  </tr>
                                  {item.creativity?<>
                                    <tr>
                                    <td>Lecturer Rating</td>
                                    <td colSpan={3}>
                                      <ul>
                                        <li className="d-flex justify-content-between">
                                          <span title=" content ">Content</span>
                                          <Progress
                                            percent={Math.floor(
                                              item.content
                                            )}
                                          />
                                        </li>
                                        <li className="d-flex justify-content-between">
                                        <span title=" creativity ">Creative Expression</span>
                                          <Progress
                                            percent={Math.floor(
                                              item.creativity
                                            )}
                                          />{" "}
                                        </li>
                                        <li className="d-flex justify-content-between">
                                          <span title="Nutral">Enthusiasm</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.enthusiasm
                                            )}
                                          />
                                        </li>
                                        <li className="d-flex justify-content-between">
                                          <span title="Sad">Emotional Stability</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.emotionalStability
                                            )}
                                          />
                                        </li>
                                        <li className="d-flex justify-content-between">
                                          <span title="angry">Comprehansive Ability</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.comprehansiveAbility
                                            )}
                                          />
                                        </li>
                                        {/* <li className="d-flex justify-content-between">
                                          <span title="fear">😱 {'fear'}</span>{" "}
                                          <Progress
                                            percent={Math.floor(
                                              item.percentage.fear
                                            )}
                                          />
                                        </li> */}
                                      </ul>
                                    </td>
                                  </tr></>:null}
                                  <tr>
                                    <td>Short Note:</td>
                                    <td colSpan={4}>
                                      {item.discription
                                        ? item.discription
                                        : "no comment available"}
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            </div>
                            <div className="totalScore">
                              <p>leacturer assigned Score</p>
                              <h2>{Math.floor(item.manualScore) + "%"}</h2>
                              <p>Machine Score</p>
                              <h2>
                                {Math.floor(item.percentage.percentage) + "%"}
                              </h2>
                              <p>Final Score</p>
                              <h2>{Math.floor(item.finalScore) + "%"}</h2>
                              <div className="mt-5">
                                <input
                                  type="checkbox"
                                  className="formcontrol"
                                  id="select"
                                  checked={
                                    item.status == "shorlisted" ? true : false
                                  }
                                  onClick={() => handleShortlist(item._id)}
                                />
                                <label htmlFor="select">
                                  Select to Shortlist
                                </label>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </div>

                  {shortresponse ? (
                    <div className="d-flex justify-content-center">
                      <Pagination>
                        {page_arr.map((i, x) => (
                          <Pagination.Item
                            key={i}
                            onClick={() => {
                              setCurrentPage(i + 1);
                            }}
                            active={i + 1 === currentPage}
                          >
                            {i + 1}
                          </Pagination.Item>
                        ))}
                      </Pagination>
                    </div>
                  ) : (
                    <></>
                  )}
                </Tab>
              </Tabs>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default VideoDetailPage;
